import ReviewObservationIndex from '@/pages/vns/observation/review_observation/Index'
import ReviewObservationForm from '@/pages/vns/observation/review_observation/Form'

const ReviewObservationRoutes = [    
    {path: '/review_observation', name: 'review_observation.index', component: ReviewObservationIndex, meta: {permission: 'review_observation.index'}},
    {path: '/review_observation/edit/:id', name: 'review_observation.edit', component: ReviewObservationForm, meta: {permission: 'review_observation.edit'}},
    {path: '/review_observation/next', name: 'review_observation.next', component: ReviewObservationForm, meta: {permission: 'review_observation.next'}},

];

export default ReviewObservationRoutes;